<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  // FIXME: 是否还需要icon？
  // import '@/assets/css/icon.css';
  export default {
    name: 'app',
  }
</script>

<style>
  @font-face {
    font-family: fashionFetish;
    src: url(assets/font/FashionFetishRegular.ttf);
  }
  body {
    background-color: #2F2F2F;
    font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue